// extracted by mini-css-extract-plugin
export default {"titleWrapper":"ModalTitle_titleWrapper__SVNgj","row":"ModalTitle_row__lwrs3","marginL":"ModalTitle_marginL__vr+hT"};